import { joinNames } from "helpers/name"

import { mapOrderDataToFormValues } from "./map-order-data-to-form-values"

const getPaymentDefaultValues = (data, type) => {
  let values = {}

  if (type === "affirm") {
    return values
  }

  const sameAsShipping =
    type === "jewlr" || data?.order?.billing_same_as_shipping
  const billFirstName =
    (sameAsShipping
      ? data?.order?.ship_address?.first_name
      : data?.order?.bill_address?.first_name) ||
    data?.order?.customer?.first_name
  const billLastName =
    (sameAsShipping
      ? data?.order?.ship_address?.last_name
      : data?.order?.bill_address?.last_name) ||
    data?.order?.customer?.last_name

  values = {
    ...values,
    bill_full_name: joinNames(billFirstName, billLastName),
  }

  if (type === "klarna" || type === "jewlr") {
    return values
  }

  values = {
    ...values,
    bill_address_attributes: {
      address1: data?.order?.bill_address?.address1 || "",
      address2: data?.order?.bill_address?.address2 || "",
      city: data?.order?.bill_address?.city || "",
      country: data?.order?.bill_address?.country || "",
      postal_code: data?.order?.bill_address?.postal_code || "",
      state: data?.order?.bill_address?.state || "",
    },
    same_as_shipping_address_b: sameAsShipping,
  }

  if (type === "default") {
    values = {
      ...values,
      cc: {
        cc_expiry_month: data?.cc?.cc_expiry_month || "",
        cc_expiry_year: data?.cc?.cc_expiry_year || "",
        cc_number: data?.cc?.number || "",
        cc_verification_value: data?.cc?.cc_verification_value || "",
        expiry: data?.cc?.expiry || "",
      },
    }
  }

  return values
}

const getPlaceOrderBtnText = (type) => {
  let paymentText = "Place Order"
  switch (type) {
    case "affirm":
      paymentText = "Order with Affirm"
      break
    case "klarna":
      paymentText = "Order with Klarna"
      break
    case "paypal":
      paymentText = "Order with Paypal"
      break
  }
  return paymentText
}

export {
  getPaymentDefaultValues,
  getPlaceOrderBtnText,
  mapOrderDataToFormValues,
}
